import type { CartItemTypeEnum } from './cart-item.ts';
import type { CartChild } from './child.ts';
import type { CommitmentFrequencyEnum } from './commitments.ts';

export enum GiftTypeEnum {
  Birthday = 'Birthday',
  Child = 'Child',
  Family = 'Family',
  Center = 'Center',
}
export enum CartItemGiftLimitFrequencyEnum {
  OneTime = 'oneTime',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Semiannually = 'semiAnnual',
  Annually = 'annual',
}
export interface GiftBirthdayPayload {
  giftType: GiftTypeEnum.Birthday;
  globalId: string;
  commitmentId?: string;
}
export interface GiftChildPayload {
  giftType: GiftTypeEnum.Child;
  globalId: string;
  commitmentId: string;
}
export interface GiftFamilyPayload {
  giftType: GiftTypeEnum.Family;
  globalId: string;
  commitmentId: string;
}
export interface GiftCenterPayload {
  giftType: GiftTypeEnum.Center;
  centerId: string;
  commitmentId: string;
  isMergedCenterGift?: boolean;
}

/**
 * @discriminator giftType
 */
export type GiftPayload =
  | GiftBirthdayPayload
  | GiftChildPayload
  | GiftFamilyPayload
  | GiftCenterPayload;

/**
 * The incoming request payload for a Gift item
 */
export interface CartItemGiftPayload {
  itemType: CartItemTypeEnum.Gift;
  commitmentFrequency: CommitmentFrequencyEnum;
  /**
   * Rate (float) of the item.
   */
  unitPrice: number;
  gift: GiftPayload;
}

export interface CartItemGiftBirthday {
  giftType: GiftTypeEnum.Birthday;
  globalId: string;
  commitmentId?: string;
}
export interface CartItemGiftChild {
  giftType: GiftTypeEnum.Child;
  globalId: string;
  commitmentId: string;
}
export interface CartItemGiftFamily {
  giftType: GiftTypeEnum.Family;
  globalId: string;
  commitmentId: string;
}
export interface CartItemGiftCenter {
  giftType: GiftTypeEnum.Center;
  centerId: string;
  commitmentId?: string;
  isMergedCenterGift?: boolean;
}

/**
 * An outgoing response Gift item
 *
 */
export interface CartItemGift {
  itemType: CartItemTypeEnum.Gift;
  title: string;
  commitmentFrequency: CommitmentFrequencyEnum;
  excludeFromToday?: boolean;
  /**
   * @discriminator giftType
   */
  gift:
    | CartItemGiftBirthday
    | CartItemGiftChild
    | CartItemGiftFamily
    | CartItemGiftCenter;
  child?: CartChild;
  availableFrequencies: Array<CommitmentFrequencyEnum>;
  limits?: {
    max: number;
    min: number;
  };
}
